import AudioEngine from '@/webgl/audio/AudioEngine'
import Sound from '@/webgl/audio/Sound'

export type AudioSourceConfig = {
  buffer: AudioBuffer
  start?: number
  end?: number
  output?: GainNode
}

export type PlayOptions = {
  volume?: number
  loop?: boolean
  delay?: number
}

export interface IAudioSource {
  play(opts: PlayOptions): Sound
  dispose(): void
}

export default class AudioSource implements IAudioSource {
  constructor(
    readonly engine: AudioEngine,
    readonly config: AudioSourceConfig
  ) {}

  play(opts: PlayOptions): Sound {
    const sound = new Sound(this)
    if (this.config.start !== undefined) sound.start = this.config.start
    if (this.config.end !== undefined && this.config.start !== undefined)
      sound.duration = this.config.end - this.config.start
    sound.play(opts)
    return sound
  }

  stop() {}

  dispose() {
    this.config.buffer = null
  }
}
